export default __webpack_public_path__ + "static/media/facebook.4ee51a08.svg";